import { APP_INVENTORY_API_BASE } from "../../../../config/api";
// /**
//  * AssetDetail  Full asset detail page
//  *
//  * Route: /inventory/assets/:id
//  *
//  * Sections:
//  *   1. Header  breadcrumb, action buttons (edit / transfer / delete)
//  *   2. Identity card  all asset fields, inline editing via PATCH
//  *   3. Ownership panel  current owner + full transfer timeline
//  *   4. Device binding panel  active binding + full history
//  *   5. Financial / warranty card
//  *   6. Audit timestamps
//  *
//  * APIs used:
//  *   GET    /assets/:id   (includes active_binding + ownership_transfers)
//  *   PATCH  /assets/:id
//  *   DELETE /assets/:id
//  *   POST   /bindings/:id/unbind
//  */

// import React, { useEffect, useState, useCallback } from "react";
// import {
//   Box, Typography, Card, CardContent, CardHeader, Button, Stack,
//   Chip, Alert, Skeleton, Divider, TextField, Tooltip, IconButton,
//   Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
//   Table, TableBody, TableRow, TableCell, TableHead, Paper,
//   CircularProgress, Collapse, Grid,
// } from "@mui/material";
// import { useParams, useNavigate, useSearchParams } from "react-router-dom";
// import axios from "axios";
// import DevicePickerModal  from "../bindings/DevicePickerModal";
// import TransferModal from "../Transfers/TransferModal";
// import LogMovementModal   from "../movements/LogMovementModal";
// import CreateLeaseModal   from "../leases/CreateLeaseModal";
// import { useAuth } from "../../../../auth/useAuth";

// // Icons
// import ArrowBackIcon        from "@mui/icons-material/ArrowBack";
// import EditIcon             from "@mui/icons-material/Edit";
// import SaveIcon             from "@mui/icons-material/Save";
// import CloseIcon            from "@mui/icons-material/Close";
// import DeleteOutlineIcon    from "@mui/icons-material/DeleteOutline";
// import SwapHorizIcon        from "@mui/icons-material/SwapHoriz";
// import LinkIcon             from "@mui/icons-material/Link";
// import LinkOffIcon          from "@mui/icons-material/LinkOff";
// import LocalShippingIcon    from "@mui/icons-material/LocalShipping";
// import HandshakeIcon        from "@mui/icons-material/Handshake";
// import WarningAmberIcon     from "@mui/icons-material/WarningAmber";
// import CheckCircleIcon      from "@mui/icons-material/CheckCircle";
// import DevicesIcon          from "@mui/icons-material/Devices";
// import HistoryIcon          from "@mui/icons-material/History";

// const API_BASE = `${APP_INVENTORY_API_BASE}`;

// // ””” Status colours ”””””””””””””””””””””””””””””””””””””””””””””””””””””””””””

// const STATUS_COLORS = {
//   IN_STOCK: { color: "#475569", bg: "#f1f5f9", border: "#cbd5e1" },
//   DEPLOYED: { color: "#15803d", bg: "#dcfce7", border: "#bbf7d0" },
//   DAMAGED:  { color: "#b91c1c", bg: "#fee2e2", border: "#fecaca" },
//   LOST:     { color: "#a16207", bg: "#fef08a", border: "#fde047" },
// };

// const OWNERSHIP_STATE_COLORS = {
//   OEM_OWNED:           { label: "OEM Owned",          color: "#1d4ed8", bg: "#eff6ff" },
//   OWNED_BY_PARTNER:    { label: "Owned by Partner",   color: "#7c3aed", bg: "#f5f3ff" },
//   OWNED_BY_CUSTOMER:   { label: "Owned by Customer",  color: "#065f46", bg: "#ecfdf5" },
//   RMA_RETURNED:        { label: "RMA Returned",       color: "#92400e", bg: "#fff7ed" },
// };

// // ””” Helper components ””””””””””””””””””””””””””””””””””””””””””””””””””””””””

// function StatusChip({ status }) {
//   const s = STATUS_COLORS[status] || STATUS_COLORS.IN_STOCK;
//   return (
//     <Chip label={status?.replace(/_/g, " ")} size="small"
//       sx={{ bgcolor: s.bg, color: s.color, fontWeight: 600, border: `1px solid ${s.border}`, borderRadius: "6px" }} />
//   );
// }

// function OwnershipChip({ state }) {
//   const s = OWNERSHIP_STATE_COLORS[state] || { label: state, color: "#374151", bg: "#f3f4f6" };
//   return (
//     <Chip label={s.label} size="small"
//       sx={{ bgcolor: s.bg, color: s.color, fontWeight: 600, borderRadius: "6px", fontSize: 11 }} />
//   );
// }

// function InfoRow({ label, value, mono = false }) {
//   return (
//     <Box display="flex" justifyContent="space-between" alignItems="flex-start"
//       py={1} sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
//       <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0, minWidth: 160 }}>
//         {label}
//       </Typography>
//       <Typography variant="body2" fontWeight={500} textAlign="right"
//         sx={{ fontFamily: mono ? "monospace" : "inherit", wordBreak: "break-all" }}>
//         {value || ""}
//       </Typography>
//     </Box>
//   );
// }

// function SectionCard({ title, icon, action, children }) {
//   return (
//     <Card elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 3, mb: 3 }}>
//       <CardHeader
//         title={<Typography variant="subtitle1" fontWeight={700}>{title}</Typography>}
//         avatar={icon}
//         action={action}
//         sx={{ pb: 0, borderBottom: "1px solid", borderColor: "divider" }} />
//       <CardContent>{children}</CardContent>
//     </Card>
//   );
// }

// function WarrantyStatus({ warrantyStart, warrantyEnd }) {
//   if (!warrantyEnd) return <Typography variant="body2" color="text.disabled">No warranty info</Typography>;
//   const today    = new Date();
//   const end      = new Date(warrantyEnd);
//   const daysLeft = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
//   const expired  = daysLeft < 0;
//   const warning  = daysLeft >= 0 && daysLeft <= 90;

//   return (
//     <Box display="flex" alignItems="center" gap={1}>
//       {expired
//         ? <WarningAmberIcon color="error" fontSize="small" />
//         : warning
//         ? <WarningAmberIcon color="warning" fontSize="small" />
//         : <CheckCircleIcon color="success" fontSize="small" />}
//       <Typography variant="body2" color={expired ? "error.main" : warning ? "warning.main" : "success.main"} fontWeight={600}>
//         {expired ? `Expired ${Math.abs(daysLeft)} days ago` : `${daysLeft} days remaining`}
//       </Typography>
//     </Box>
//   );
// }

// // ””” Edit form ””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””

// const EDITABLE_FIELDS = [
//   { name: "asset_type",          label: "Asset type",      col: 1 },
//   { name: "model",               label: "Model",           col: 1 },
//   { name: "manufacturer",        label: "Manufacturer",    col: 1 },
//   { name: "manufacturing_batch", label: "Batch number",    col: 1 },
//   { name: "imei",                label: "IMEI",            col: 2 },
//   { name: "mac_address",         label: "MAC address",     col: 2 },
//   { name: "qr_code",             label: "QR code",         col: 2 },
//   { name: "purchase_order",      label: "Purchase order",  col: 2 },
//   { name: "invoice_number",      label: "Invoice number",  col: 2 },
//   { name: "warranty_start",      label: "Warranty start",  col: 3, hint: "YYYY-MM-DD" },
//   { name: "warranty_end",        label: "Warranty end",    col: 3, hint: "YYYY-MM-DD" },
// ];

// function EditForm({ asset, onSave, onCancel, token, activeOrg }) {
//   const [form,    setForm]    = useState(Object.fromEntries(EDITABLE_FIELDS.map(f => [f.name, asset[f.name] || ""])));
//   const [errors,  setErrors]  = useState({});
//   const [saving,  setSaving]  = useState(false);

//   const handleChange = (name, value) => {
//     setForm(f  => ({ ...f,  [name]: value }));
//     setErrors(e => ({ ...e, [name]: ""    }));
//   };

//   const handleSave = async () => {
//     setSaving(true);
//     try {
//       const res = await axios.patch(`${API_BASE}/assets/${asset.id}`, form, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           ...(activeOrg ? { "X-Org-ID": activeOrg.id } : {}),
//         },
//       });
//       onSave(res.data);
//     } catch (err) {
//       const msg = err.response?.data?.error || "Save failed";
//       setErrors({ _global: msg });
//       setSaving(false);
//     }
//   };

//   const col1 = EDITABLE_FIELDS.filter(f => f.col === 1);
//   const col2 = EDITABLE_FIELDS.filter(f => f.col === 2);
//   const col3 = EDITABLE_FIELDS.filter(f => f.col === 3);

//   return (
//     <Box>
//       {errors._global && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{errors._global}</Alert>}
//       <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={3} mb={2}>
//         <Stack spacing={2}>
//           <Typography variant="overline" color="text.secondary" fontWeight={700}>Identity</Typography>
//           {col1.map(f => (
//             <TextField key={f.name} size="small" fullWidth label={f.label}
//               value={form[f.name]} error={!!errors[f.name]} helperText={errors[f.name]}
//               onChange={e => handleChange(f.name, e.target.value)} />
//           ))}
//         </Stack>
//         <Stack spacing={2}>
//           <Typography variant="overline" color="text.secondary" fontWeight={700}>Hardware IDs</Typography>
//           {col2.map(f => (
//             <TextField key={f.name} size="small" fullWidth label={f.label}
//               value={form[f.name]} error={!!errors[f.name]} helperText={errors[f.name]}
//               onChange={e => handleChange(f.name, e.target.value)} />
//           ))}
//         </Stack>
//       </Box>
//       <Divider sx={{ my: 2 }} />
//       <Typography variant="overline" color="text.secondary" fontWeight={700} display="block" mb={1.5}>
//         Warranty
//       </Typography>
//       <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={3}>
//         {col3.map(f => (
//           <TextField key={f.name} size="small" fullWidth label={f.label}
//             placeholder="YYYY-MM-DD"
//             value={form[f.name]} error={!!errors[f.name]} helperText={errors[f.name] || f.hint}
//             onChange={e => handleChange(f.name, e.target.value)} />
//         ))}
//       </Box>
//       <Stack direction="row" spacing={1.5} justifyContent="flex-end" mt={3}>
//         <Button onClick={onCancel} color="inherit" sx={{ textTransform: "none" }}>Cancel</Button>
//         <Button variant="contained" disableElevation onClick={handleSave}
//           disabled={saving}
//           startIcon={saving ? <CircularProgress size={14} color="inherit" /> : <SaveIcon fontSize="small" />}
//           sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}>
//           {saving ? "Saving¦" : "Save changes"}
//         </Button>
//       </Stack>
//     </Box>
//   );
// }

// // ””” Delete confirm dialog ””””””””””””””””””””””””””””””””””””””””””””””””””””

// function UnbindDialog({ open, binding, token, activeOrg, onClose, onUnbound }) {
//   const [submitting, setSubmitting] = useState(false);
//   const [error,      setError]      = useState("");

//   const handleUnbind = async () => {
//     setSubmitting(true);
//     setError("");
//     try {
//       await axios.post(`${API_BASE}/bindings/${binding.id}/unbind`, {}, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           ...(activeOrg ? { "X-Org-ID": activeOrg.id } : {}),
//         },
//       });
//       onUnbound();
//     } catch (err) {
//       setError(err.response?.data?.error || "Unbind failed");
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
//       PaperProps={{ sx: { borderRadius: 3 } }}>
//       <DialogTitle fontWeight={700}>Unbind device?</DialogTitle>
//       <DialogContent>
//         {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}
//         <DialogContentText>
//           This will remove the binding to device <strong>{binding?.device_id}</strong>.
//           The asset status will return to <strong>IN_STOCK</strong>.
//         </DialogContentText>
//       </DialogContent>
//       <DialogActions sx={{ px: 3, pb: 2 }}>
//         <Button onClick={onClose} color="inherit" sx={{ textTransform: "none" }}>Cancel</Button>
//         <Button variant="contained" color="warning" disableElevation disabled={submitting}
//           onClick={handleUnbind}
//           startIcon={submitting ? <CircularProgress size={14} color="inherit" /> : <LinkOffIcon />}
//           sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}>
//           {submitting ? "Unbinding¦" : "Unbind"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// // ”””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””
// // MAIN PAGE
// // ”””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””

// export default function AssetDetail() {
//   const { id }         = useParams();
//   const navigate       = useNavigate();
//   const [searchParams] = useSearchParams();
//   const { permissions, activeOrg } = useAuth();
//   const token          = localStorage.getItem("authToken");

//   const [asset,        setAsset]        = useState(null);
//   const [loading,      setLoading]      = useState(true);
//   const [error,        setError]        = useState(null);
//   const [editing,      setEditing]      = useState(false);
//   const [deleteOpen,   setDeleteOpen]   = useState(false);
//   const [unbindOpen,   setUnbindOpen]   = useState(false);
//   const [transferOpen, setTransferOpen] = useState(false);
//   const [bindOpen,     setBindOpen]     = useState(false);
//   const [movementOpen, setMovementOpen] = useState(false);
//   const [movements,    setMovements]    = useState([]);
//   const [leaseOpen,    setLeaseOpen]    = useState(false);
//   const [leases,       setLeases]       = useState([]);
//   const [successMsg,   setSuccessMsg]   = useState("");

//   const hasPermission = p => {
//     if (!permissions || permissions.size === 0) return false;
//     if (permissions.has("*")) return true;
//     return permissions.has(p);
//   };

//   const authHeaders = {
//     Authorization: `Bearer ${token}`,
//     ...(activeOrg ? { "X-Org-ID": activeOrg.id } : {}),
//   };

//   const showSuccess = msg => {
//     setSuccessMsg(msg);
//     setTimeout(() => setSuccessMsg(""), 5000);
//   };

//   // ”” Fetch asset ””
//   const fetchAsset = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API_BASE}/assets/${id}`, { headers: authHeaders });
//       setAsset(res.data);
//       setError(null);
//     } catch (err) {
//       if (err.response?.status === 404) setError("Asset not found.");
//       else if (err.response?.status === 403) setError("You don't have permission to view this asset.");
//       else setError("Failed to load asset details.");
//     } finally {
//       setLoading(false);
//     }
//   }, [id, token, activeOrg]);

//   useEffect(() => { fetchAsset(); }, [fetchAsset]);

//   const fetchMovements = useCallback(async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/movements/${activeOrg.id}`, {
//         headers: authHeaders,
//         params: { asset_id: id, per_page: 10 },
//       });
//       setMovements(res.data.data || []);
//     } catch { setMovements([]); }
//   }, [id, token, activeOrg]);

//   useEffect(() => { if (id) fetchMovements(); }, [fetchMovements]);

//   const fetchLeases = useCallback(async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/leases`, {
//         headers: authHeaders,
//         params: { asset_id: id, per_page: 5 },
//       });
//       setLeases(res.data.data || []);
//     } catch { setLeases([]); }
//   }, [id, token, activeOrg]);

//   useEffect(() => { if (id) fetchLeases(); }, [fetchLeases]);

//   // Auto-open transfer modal if navigated with ?action=transfer
//   useEffect(() => {
//     if (searchParams.get("action") === "transfer" && asset) {
//       setTransferOpen(true);
//     }
//   }, [searchParams, asset]);

//   // ”” Handlers ””
//   const handleSaved = (updatedAsset) => {
//     setAsset(updatedAsset);
//     setEditing(false);
//     showSuccess("Asset updated successfully.");
//   };

//   const handleTransferSuccess = (transfer, updatedAsset) => {
//     setTransferOpen(false);
//     setAsset(updatedAsset);
//     showSuccess(`Ownership transferred to ${updatedAsset.owner_type}. State is now ${updatedAsset.ownership_state?.replace(/_/g, " ")}.`);
//   };

//   const handleLeaseSuccess = (lease) => {
//     setLeaseOpen(false);
//     fetchLeases();
//     showSuccess("Lease created successfully.");
//   };

//   const handleMovementSuccess = (movement) => {
//     setMovementOpen(false);
//     fetchMovements();
//     showSuccess("Movement logged successfully.");
//   };

//   const handleBindSuccess = (binding, updatedAsset) => {
//     setBindOpen(false);
//     setAsset(updatedAsset);
//     showSuccess(`Asset bound to device successfully. Status is now DEPLOYED.`);
//   };

//   const handleDeleted = () => {
//     navigate("/inventory/assets", { replace: true });
//   };

//   const handleUnbound = () => {
//     setUnbindOpen(false);
//     fetchAsset();
//     showSuccess("Asset unbound from device. Status is now IN_STOCK.");
//   };

//   // ”” Loading skeleton ””
//   if (loading) return (
//     <Box sx={{ maxWidth: 1100, margin: "0 auto", p: { xs: 2, md: 3 } }}>
//       <Skeleton variant="text" width={200} height={32} sx={{ mb: 3 }} />
//       <Skeleton variant="rounded" height={200} sx={{ mb: 3, borderRadius: 3 }} />
//       <Skeleton variant="rounded" height={180} sx={{ mb: 3, borderRadius: 3 }} />
//       <Skeleton variant="rounded" height={180} sx={{ borderRadius: 3 }} />
//     </Box>
//   );

//   if (error) return (
//     <Box sx={{ maxWidth: 1100, margin: "0 auto", p: { xs: 2, md: 3 } }}>
//       <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)} sx={{ textTransform: "none", mb: 2 }}>
//         Back
//       </Button>
//       <Alert severity="error" sx={{ borderRadius: 2 }}>{error}</Alert>
//     </Box>
//   );

//   const activeBinding    = asset.active_binding;
//   const transfers        = asset.ownership_transfers || [];

//   return (
//     <Box sx={{ maxWidth: 1100, margin: "0 auto", p: { xs: 2, md: 3 } }}>

//       {/* ”” Header ”” */}
//       <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={3} flexWrap="wrap" gap={2}>
//         <Box>
//           <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("/inventory/assets")}
//             sx={{ textTransform: "none", mb: 0.5, color: "text.secondary", pl: 0 }}>
//             Hardware Inventory
//           </Button>
//           <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
//             <Typography variant="h5" fontWeight={700} sx={{ fontFamily: "monospace" }}>
//               {asset.serial_number}
//             </Typography>
//             <StatusChip status={asset.status} />
//             <OwnershipChip state={asset.ownership_state} />
//           </Box>
//           <Typography variant="body2" color="text.secondary" mt={0.5}>
//             {asset.asset_type} · {asset.model}
//             {asset.manufacturer ? ` · ${asset.manufacturer}` : ""}
//           </Typography>
//         </Box>

//         {/* Action buttons */}
//         <Stack direction="row" spacing={1} flexWrap="wrap">
//           {hasPermission("inventory.asset.update") && !editing && (
//             <Button startIcon={<EditIcon />} variant="outlined" size="small"
//               onClick={() => setEditing(true)}
//               sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}>
//               Edit
//             </Button>
//           )}
//           {hasPermission("inventory.transfer.create") && (
//             <Button startIcon={<SwapHorizIcon />} variant="outlined" size="small"
//               onClick={() => setTransferOpen(true)}
//               sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}>
//               Transfer
//             </Button>
//           )}
//           {hasPermission("inventory.asset.delete") && (
//             <Button startIcon={<DeleteOutlineIcon />} variant="outlined" color="error" size="small"
//               onClick={() => setDeleteOpen(true)}
//               disabled={asset.status === "DEPLOYED"}
//               sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}>
//               Delete
//             </Button>
//           )}
//         </Stack>
//       </Stack>

//       {/* Alerts */}
//       <Collapse in={!!successMsg}>
//         <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }} onClose={() => setSuccessMsg("")}>
//           {successMsg}
//         </Alert>
//       </Collapse>

//       {/* ”” Edit mode ”” */}
//       {editing ? (
//         <Card elevation={0} sx={{ border: "1px solid", borderColor: "primary.200", borderRadius: 3, mb: 3, bgcolor: "primary.50" }}>
//           <CardHeader
//             title={<Typography variant="subtitle1" fontWeight={700}>Edit asset</Typography>}
//             subheader="serial_number and status cannot be changed here"
//             action={<IconButton onClick={() => setEditing(false)}><CloseIcon /></IconButton>}
//             sx={{ borderBottom: "1px solid", borderColor: "divider" }} />
//           <CardContent>
//             <EditForm asset={asset} token={token} activeOrg={activeOrg}
//               onSave={handleSaved} onCancel={() => setEditing(false)} />
//           </CardContent>
//         </Card>
//       ) : (
//         <>
//           {/* ”” Section 1: Identity ”” */}
//           <SectionCard title="Identity & hardware"
//             icon={<DevicesIcon color="primary" />}
//             action={hasPermission("inventory.asset.update") && (
//               <Tooltip title="Edit"><IconButton size="small" onClick={() => setEditing(true)}><EditIcon fontSize="small" /></IconButton></Tooltip>
//             )}>
//             <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={3}>
//               <Box>
//                 <Typography variant="overline" color="text.secondary" fontWeight={700} display="block" mb={1}>
//                   Identity
//                 </Typography>
//                 <InfoRow label="Serial number"    value={asset.serial_number}       mono />
//                 <InfoRow label="Asset type"       value={asset.asset_type} />
//                 <InfoRow label="Model"            value={asset.model} />
//                 <InfoRow label="Manufacturer"     value={asset.manufacturer} />
//                 <InfoRow label="Batch number"     value={asset.manufacturing_batch} />
//               </Box>
//               <Box>
//                 <Typography variant="overline" color="text.secondary" fontWeight={700} display="block" mb={1}>
//                   Hardware IDs
//                 </Typography>
//                 <InfoRow label="IMEI"         value={asset.imei}        mono />
//                 <InfoRow label="MAC address"  value={asset.mac_address} mono />
//                 <InfoRow label="QR code"      value={asset.qr_code}     mono />
//                 <InfoRow label="Purchase order"  value={asset.purchase_order} />
//                 <InfoRow label="Invoice number"  value={asset.invoice_number} />
//               </Box>
//             </Box>
//           </SectionCard>

//           {/* ”” Section 2: Ownership ”” */}
//           <SectionCard title="Ownership"
//             icon={<SwapHorizIcon color="secondary" />}
//             action={hasPermission("inventory.transfer.create") && (
//               <Button size="small" startIcon={<SwapHorizIcon />}
//                 onClick={() => setTransferOpen(true)}
//                 sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}>
//                 Transfer
//               </Button>
//             )}>
//             <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={3} mb={3}>
//               <Box>
//                 <Typography variant="overline" color="text.secondary" fontWeight={700} display="block" mb={1}>
//                   Current owner
//                 </Typography>
//                 <InfoRow label="Owner type"      value={asset.owner_type} />
//                 <InfoRow label="Owner org"       value={asset.owner_org_id} mono />
//                 <InfoRow label="Ownership state" value={asset.ownership_state?.replace(/_/g, " ")} />
//                 <InfoRow label="Assigned org"    value={asset.organization_id} mono />
//               </Box>
//               <Box>
//                 <Typography variant="overline" color="text.secondary" fontWeight={700} display="block" mb={1}>
//                   Procurement
//                 </Typography>
//                 <InfoRow label="Source"         value={asset.procurement_source} />
//                 <InfoRow label="Purchase order" value={asset.purchase_order} />
//                 <InfoRow label="Invoice"        value={asset.invoice_number} />
//               </Box>
//             </Box>

//             {/* Transfer timeline */}
//             {transfers.length > 0 && (
//               <>
//                 <Divider sx={{ mb: 2 }} />
//                 <Typography variant="overline" color="text.secondary" fontWeight={700} display="block" mb={1.5}>
//                   Ownership history ({transfers.length})
//                 </Typography>
//                 <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow sx={{ "& th": { bgcolor: "background.default", fontWeight: 700, fontSize: 11, color: "text.secondary" } }}>
//                         <TableCell>Type</TableCell>
//                         <TableCell>From</TableCell>
//                         <TableCell>To</TableCell>
//                         <TableCell>Status</TableCell>
//                         <TableCell>Date</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {transfers.map(t => (
//                         <TableRow key={t.id} hover>
//                           <TableCell sx={{ fontSize: 12 }}>
//                             <Chip label={t.transfer_type?.replace(/_/g, " ")} size="small" variant="outlined"
//                               sx={{ fontSize: 10, height: 20 }} />
//                           </TableCell>
//                           <TableCell sx={{ fontSize: 12 }}>
//                             {t.from_owner_type}{t.from_owner_org_id ? ` · ${t.from_owner_org_id.slice(0, 8)}¦` : ""}
//                           </TableCell>
//                           <TableCell sx={{ fontSize: 12 }}>
//                             {t.to_owner_type}{t.to_owner_org_id ? ` · ${t.to_owner_org_id.slice(0, 8)}¦` : ""}
//                           </TableCell>
//                           <TableCell>
//                             <Chip label={t.transfer_status} size="small" color="success" variant="outlined"
//                               sx={{ fontSize: 10, height: 20 }} />
//                           </TableCell>
//                           <TableCell sx={{ fontSize: 11, color: "text.secondary", whiteSpace: "nowrap" }}>
//                             {t.transferred_at ? new Date(t.transferred_at).toLocaleDateString("en-IN", {
//                               day: "numeric", month: "short", year: "numeric",
//                             }) : ""}
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </Paper>
//               </>
//             )}
//           </SectionCard>

//           {/* ”” Section 3: Device binding ”” */}
//           <SectionCard title="Device binding"
//             icon={<LinkIcon color="action" />}
//             action={activeBinding && hasPermission("inventory.binding.remove") && (
//               <Button size="small" color="warning" startIcon={<LinkOffIcon />}
//                 onClick={() => setUnbindOpen(true)}
//                 sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}>
//                 Unbind
//               </Button>
//             )}>
//             {activeBinding ? (
//               <Box>
//                 <Alert severity="success" icon={<LinkIcon />} sx={{ mb: 2, borderRadius: 2 }}>
//                   Currently bound to device
//                 </Alert>
//                 <InfoRow label="Device ID" value={activeBinding.device_id} mono />
//                 <InfoRow label="Bound at"  value={activeBinding.bound_at
//                   ? new Date(activeBinding.bound_at).toLocaleString("en-IN") : ""} />
//                 <InfoRow label="Bound by"  value={activeBinding.bound_by} mono />
//               </Box>
//             ) : (
//               <Box textAlign="center" py={2}>
//                 <LinkOffIcon sx={{ fontSize: 36, color: "text.disabled", mb: 1 }} />
//                 <Typography variant="body2" color="text.secondary" fontWeight={600}>
//                   Not bound to any device
//                 </Typography>
//                 <Typography variant="caption" color="text.disabled">
//                   {asset.ownership_state === "OWNED_BY_CUSTOMER"
//                     ? "This asset is ready to be bound to a device."
//                     : "Transfer asset to a customer before binding."}
//                 </Typography>
//                 {asset.ownership_state === "OWNED_BY_CUSTOMER" && hasPermission("inventory.binding.create") && (
//                   <Box mt={2}>
//                     <Button size="small" variant="outlined" startIcon={<LinkIcon />}
//                       onClick={() => setBindOpen(true)}
//                       sx={{ textTransform: "none", fontWeight: 600 }}>
//                       Bind to device
//                     </Button>
//                   </Box>
//                 )}
//               </Box>
//             )}
//           </SectionCard>

//           {/* ”” Section 4: Movements ”” */}
//           <SectionCard title="Movement history"
//             icon={<LocalShippingIcon color="action" />}
//             action={hasPermission("inventory.movement.create") && (
//               <Button size="small" startIcon={<LocalShippingIcon />}
//                 onClick={() => setMovementOpen(true)}
//                 sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}>
//                 Log movement
//               </Button>
//             )}>
//             {movements.length === 0 ? (
//               <Box textAlign="center" py={2}>
//                 <Typography variant="body2" color="text.secondary" fontWeight={600}>No movements recorded</Typography>
//                 <Typography variant="caption" color="text.disabled">Physical shipments and transfers will appear here</Typography>
//               </Box>
//             ) : (
//               <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
//                 <Table size="small">
//                   <TableHead>
//                     <TableRow sx={{ "& th": { bgcolor: "background.default", fontWeight: 700, fontSize: 11, color: "text.secondary" } }}>
//                       <TableCell>Type</TableCell>
//                       <TableCell>From</TableCell>
//                       <TableCell>To</TableCell>
//                       <TableCell>Courier</TableCell>
//                       <TableCell>Date</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {movements.map(m => (
//                       <TableRow key={m.id} hover>
//                         <TableCell><Chip label={m.movement_type} size="small" variant="outlined" sx={{ fontSize: 10, height: 20 }} /></TableCell>
//                         <TableCell sx={{ fontSize: 12, color: "text.secondary" }}>{m.from_location_name || ""}</TableCell>
//                         <TableCell sx={{ fontSize: 12, color: "text.secondary" }}>{m.to_location_name   || ""}</TableCell>
//                         <TableCell sx={{ fontSize: 12, color: "text.secondary" }}>{m.courier_name       || ""}</TableCell>
//                         <TableCell sx={{ fontSize: 11, color: "text.secondary", whiteSpace: "nowrap" }}>
//                           {m.moved_at ? new Date(m.moved_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : ""}
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </Paper>
//             )}
//           </SectionCard>

//           {/* ”” Section 5: Leases ”” */}
//           <SectionCard title="Leases"
//             icon={<HandshakeIcon color="action" />}
//             action={hasPermission("inventory.lease.create") && asset.ownership_state === "OWNED_BY_CUSTOMER" && (
//               <Button size="small" startIcon={<HandshakeIcon />}
//                 onClick={() => setLeaseOpen(true)}
//                 sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}>
//                 Create lease
//               </Button>
//             )}>
//             {leases.length === 0 ? (
//               <Box textAlign="center" py={2}>
//                 <Typography variant="body2" color="text.secondary" fontWeight={600}>No leases recorded</Typography>
//                 <Typography variant="caption" color="text.disabled">
//                   {asset.ownership_state === "OWNED_BY_CUSTOMER"
//                     ? "Create a lease agreement for this asset"
//                     : "Asset must be OWNED_BY_CUSTOMER before leasing"}
//                 </Typography>
//               </Box>
//             ) : (
//               <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
//                 <Table size="small">
//                   <TableHead>
//                     <TableRow sx={{ "& th": { bgcolor: "background.default", fontWeight: 700, fontSize: 11, color: "text.secondary" } }}>
//                       <TableCell>Status</TableCell>
//                       <TableCell>Period</TableCell>
//                       <TableCell>Rate</TableCell>
//                       <TableCell>Contract ref</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {leases.map(l => (
//                       <TableRow key={l.id} hover>
//                         <TableCell>
//                           <Chip label={l.lease_status} size="small" variant="outlined"
//                             color={l.lease_status === "ACTIVE" ? "success" : "default"}
//                             sx={{ fontSize: 10, height: 20 }} />
//                         </TableCell>
//                         <TableCell sx={{ fontSize: 12, color: "text.secondary" }}>
//                           {l.start_date} †’ {l.end_date}
//                         </TableCell>
//                         <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>
//                           {l.currency} {parseFloat(l.rate).toLocaleString("en-IN")}
//                           <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
//                             /{l.billing_cycle?.toLowerCase()}
//                           </Typography>
//                         </TableCell>
//                         <TableCell sx={{ fontSize: 12, color: "text.secondary" }}>
//                           {l.contract_reference || ""}
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </Paper>
//             )}
//           </SectionCard>

//           {/* ”” Section 6: Warranty & audit ”” */}
//           <Card elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 3, mb: 3 }}>
//             <CardContent>
//               <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={3}>
//                 <Box>
//                   <Typography variant="overline" color="text.secondary" fontWeight={700} display="block" mb={1}>
//                     Warranty
//                   </Typography>
//                   <InfoRow label="Start date" value={asset.warranty_start} />
//                   <InfoRow label="End date"   value={asset.warranty_end} />
//                   <Box mt={1.5}>
//                     <WarrantyStatus warrantyStart={asset.warranty_start} warrantyEnd={asset.warranty_end} />
//                   </Box>
//                 </Box>
//                 <Box>
//                   <Typography variant="overline" color="text.secondary" fontWeight={700} display="block" mb={1}>
//                     Audit
//                   </Typography>
//                   <InfoRow label="Registered"   value={asset.created_at  ? new Date(asset.created_at).toLocaleString("en-IN")  : ""} />
//                   <InfoRow label="Last updated" value={asset.updated_at  ? new Date(asset.updated_at).toLocaleString("en-IN")  : ""} />
//                   <InfoRow label="Asset ID"     value={asset.id} mono />
//                 </Box>
//               </Box>
//             </CardContent>
//           </Card>
//         </>
//       )}

//       {/* ”” Dialogs ”” */}
//       <DeleteDialog open={deleteOpen} asset={asset} token={token} activeOrg={activeOrg}
//         onClose={() => setDeleteOpen(false)} onDeleted={handleDeleted} />

//       <UnbindDialog open={unbindOpen} binding={activeBinding} token={token} activeOrg={activeOrg}
//         onClose={() => setUnbindOpen(false)} onUnbound={handleUnbound} />

//       <TransferModal open={transferOpen} asset={asset} token={token} activeOrg={activeOrg}
//         onClose={() => setTransferOpen(false)} onSuccess={handleTransferSuccess} />

//       <DevicePickerModal open={bindOpen} asset={asset} token={token} activeOrg={activeOrg}
//         onClose={() => setBindOpen(false)} onSuccess={handleBindSuccess} />

//       <LogMovementModal open={movementOpen} asset={asset} token={token} activeOrg={activeOrg}
//         onClose={() => setMovementOpen(false)} onSuccess={handleMovementSuccess} />

//       <CreateLeaseModal open={leaseOpen} asset={asset} token={token} activeOrg={activeOrg}
//         onClose={() => setLeaseOpen(false)} onSuccess={handleLeaseSuccess} />

//     </Box>
//   );
// }

/**
 * AssetDetail  Full asset detail page
 *
 * Route: /inventory/assets/:id
 *
 * Sections:
 *   1. Header  breadcrumb, action buttons (edit / transfer / delete)
 *   2. Identity card  all asset fields, inline editing via PATCH
 *   3. Ownership panel  current owner + full transfer timeline
 *   4. Device binding panel  active binding + full history
 *   5. Financial / warranty card
 *   6. Audit timestamps
 *
 * APIs used:
 *   GET    /assets/:id   (includes active_binding + ownership_transfers)
 *   PATCH  /assets/:id
 *   DELETE /assets/:id
 *   POST   /bindings/:id/unbind
 */

import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Button,
  Stack,
  Chip,
  Alert,
  Skeleton,
  Divider,
  TextField,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Paper,
  CircularProgress,
  Collapse,
  Grid,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import DevicePickerModal from "../bindings/DevicePickerModal";
import LogMovementModal from "../movements/LogMovementModal";
import CreateLeaseModal from "../leases/CreateLeaseModal";
import OpenRMAModal from "../rma/OpenRMAModal";
import TransferModal from "../Transfers/TransferModal";

// Icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HandshakeIcon from "@mui/icons-material/Handshake";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DevicesIcon from "@mui/icons-material/Devices";
import HistoryIcon from "@mui/icons-material/History";
import CategoryIcon from "@mui/icons-material/Category";
import { useAuth } from "../../../../auth/useAuth";
import { useNotification } from "../../../../context/NotificationContext";

const API_BASE = `${APP_INVENTORY_API_BASE}`;

// ””” Status colours ”””””””””””””””””””””””””””””””””””””””””””””””””””””””””””

const STATUS_COLORS = {
  IN_STOCK: { color: "#475569", bg: "#DFE5F3", border: "#cbd5e1" },
  DEPLOYED: { color: "#15803d", bg: "#dcfce7", border: "#bbf7d0" },
  DAMAGED: { color: "#b91c1c", bg: "#fee2e2", border: "#fecaca" },
  LOST: { color: "#a16207", bg: "#fef08a", border: "#fde047" },
};

const OWNERSHIP_STATE_COLORS = {
  OEM_OWNED: { label: "OEM Owned", color: "#1d4ed8", bg: "#eff6ff" },
  OWNED_BY_PARTNER: {
    label: "Owned by Partner",
    color: "#7c3aed",
    bg: "#f5f3ff",
  },
  OWNED_BY_CUSTOMER: {
    label: "Owned by Customer",
    color: "#065f46",
    bg: "#ecfdf5",
  },
  RMA_RETURNED: { label: "RMA Returned", color: "#92400e", bg: "#fff7ed" },
};

// ””” Helper components ””””””””””””””””””””””””””””””””””””””””””””””””””””””””

function StatusChip({ status }) {
  const s = STATUS_COLORS[status] || STATUS_COLORS.IN_STOCK;
  return (
    <Chip
      label={status?.replace(/_/g, " ")}
      size="small"
      sx={{
        bgcolor: s.bg,
        color: s.color,
        fontWeight: 600,
        fontSize: 11,
        border: `1px solid ${s.border}`,
        borderRadius: "6px",
      }}
    />
  );
}

function OwnershipChip({ state }) {
  const s = OWNERSHIP_STATE_COLORS[state] || {
    label: state,
    color: "#374151",
    bg: "#f3f4f6",
  };
  return (
    <Chip
      label={s.label}
      size="small"
      sx={{
        bgcolor: s.bg,
        color: s.color,
        fontWeight: 600,
        borderRadius: "6px",
        fontSize: 11,
      }}
    />
  );
}

function formatOrgLabel(org, fallbackId, fallbackType) {
  if (org?.name && org?.code) return `${org.name} (${org.code})`;
  if (org?.name) return org.name;
  if (fallbackType === "OEM" && !fallbackId) return "OEM (no org)";
  return fallbackId || "";
}

function formatTypedValue(value) {
  if (value === null || value === undefined || value === "") return "";
  if (Array.isArray(value)) return value.join(", ") || "";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

function InfoRow({ label, value, mono = false }) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      py={1}
      sx={{ borderBottom: "1px solid", borderColor: "divider" }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ flexShrink: 0, minWidth: 160 }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        fontWeight={500}
        textAlign="right"
        sx={{
          fontFamily: mono ? "monospace" : "inherit",
          wordBreak: "break-all",
        }}
      >
        {value || ""}
      </Typography>
    </Box>
  );
}

function SectionCard({ title, icon, action, children }) {
  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid rgba(148, 163, 184, 0.18)",
        borderRadius: 3,
        mb: 3,
        overflow: "hidden",
      }}
    >
      <CardHeader
        title={
          <Typography
            variant="subtitle1"
            fontWeight={700}
            sx={{ color: "#e2f8f5" }}
          >
            {title}
          </Typography>
        }
        avatar={
          icon
            ? React.cloneElement(icon, {
                sx: { color: "#5eead4", fontSize: 20, ...icon.props?.sx },
              })
            : undefined
        }
        action={
          action
            ? React.cloneElement(action, {
                sx: {
                  color: "rgba(203, 213, 225, 0.80)",
                  "&:hover": {
                    color: "#e2f8f5",
                    background: "rgba(255,255,255,0.08)",
                  },
                  ...action.props?.sx,
                },
              })
            : undefined
        }
        sx={{
          pb: 1,
          borderBottom: "1px solid rgba(148, 163, 184, 0.18)",
          background:
            "linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",
          "& .MuiCardHeader-subheader": {
            color: "rgba(203, 213, 225, 0.75)",
          },
        }}
      />
      <CardContent>{children}</CardContent>
    </Card>
  );
}

function WarrantyStatus({ warrantyStart, warrantyEnd }) {
  if (!warrantyEnd)
    return (
      <Typography variant="body2" color="text.disabled">
        No warranty info
      </Typography>
    );
  const today = new Date();
  const end = new Date(warrantyEnd);
  const daysLeft = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
  const expired = daysLeft < 0;
  const warning = daysLeft >= 0 && daysLeft <= 90;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {expired ? (
        <WarningAmberIcon color="error" fontSize="small" />
      ) : warning ? (
        <WarningAmberIcon color="warning" fontSize="small" />
      ) : (
        <CheckCircleIcon color="success" fontSize="small" />
      )}
      <Typography
        variant="body2"
        color={
          expired ? "error.main" : warning ? "warning.main" : "success.main"
        }
        fontWeight={600}
      >
        {expired
          ? `Expired ${Math.abs(daysLeft)} days ago`
          : `${daysLeft} days remaining`}
      </Typography>
    </Box>
  );
}

// ””” Edit form ””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””

const EDITABLE_FIELDS = [
  { name: "asset_type", label: "Asset type", col: 1 },
  { name: "model", label: "Model", col: 1 },
  { name: "manufacturer", label: "Manufacturer", col: 1 },
  { name: "manufacturing_batch", label: "Batch number", col: 1 },
  { name: "imei", label: "IMEI", col: 2 },
  { name: "mac_address", label: "MAC address", col: 2 },
  { name: "qr_code", label: "QR code", col: 2 },
  { name: "purchase_order", label: "Purchase order", col: 2 },
  { name: "invoice_number", label: "Invoice number", col: 2 },
  {
    name: "warranty_start",
    label: "Warranty start",
    col: 3,
    hint: "YYYY-MM-DD",
  },
  { name: "warranty_end", label: "Warranty end", col: 3, hint: "YYYY-MM-DD" },
];

function EditForm({ asset, onSave, onCancel, token, activeOrg }) {
  const [form, setForm] = useState(
    Object.fromEntries(
      EDITABLE_FIELDS.map((f) => [f.name, asset[f.name] || ""]),
    ),
  );
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handleChange = (name, value) => {
    setForm((f) => ({ ...f, [name]: value }));
    setErrors((e) => ({ ...e, [name]: "" }));
  };

  // validation added
  const validate = () => {
    let newErrors = {};

    if (!form.asset_type?.trim()) newErrors.asset_type = "Required";
    if (!form.model?.trim()) newErrors.model = "Required";
    if (!form.manufacturer?.trim()) newErrors.manufacturer = "Required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
     if (!validate()) return;
    setSaving(true);
    try {
      const res = await axios.patch(`${API_BASE}/assets/${asset.id}`, form, {
        headers: {
          Authorization: `Bearer ${token}`,
          ...(activeOrg ? { "X-Org-ID": activeOrg.id } : {}),
        },
      });
      onSave(res.data);
    } catch (err) {
      const msg = err.response?.data?.error || "Save failed";
      setErrors({ _global: msg });
      setSaving(false);
    }
  };

  const col1 = EDITABLE_FIELDS.filter((f) => f.col === 1);
  const col2 = EDITABLE_FIELDS.filter((f) => f.col === 2);
  const col3 = EDITABLE_FIELDS.filter((f) => f.col === 3);

  return (
    <Box>
      {errors._global && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
          {errors._global}
        </Alert>
      )}
      <Box
        display="grid"
        gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
        gap={3}
        mb={2}
      >
        <Stack spacing={2}>
          <Typography
            variant="overline"
            color="text.secondary"
            fontWeight={700}
          >
            Identity
          </Typography>
          {col1.map((f) => (
            <TextField
              key={f.name}
              size="small"
              fullWidth
              label={
                f.name === "asset_type" ||
                f.name === "model" ||
                f.name === "manufacturer"
                  ? `${f.label} *`
                  : f.label
              }
              value={form[f.name]}
              error={!!errors[f.name]}
              helperText={errors[f.name]}
              onChange={(e) => handleChange(f.name, e.target.value)}
            />
          ))}
        </Stack>
        <Stack spacing={2}>
          <Typography
            variant="overline"
            color="text.secondary"
            fontWeight={700}
          >
            Hardware IDs
          </Typography>
          {col2.map((f) => (
            <TextField
              key={f.name}
              size="small"
              fullWidth
              label={f.label}
              value={form[f.name]}
              error={!!errors[f.name]}
              helperText={errors[f.name]}
              onChange={(e) => handleChange(f.name, e.target.value)}
            />
          ))}
        </Stack>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Typography
        variant="overline"
        color="text.secondary"
        fontWeight={700}
        display="block"
        mb={1.5}
      >
        Warranty
      </Typography>
      <Box
        display="grid"
        gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
        gap={3}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {col3.map((f) => (
            <DatePicker
              key={f.name}
              label={f.label}
              value={form[f.name] ? dayjs(form[f.name]) : null}
              onChange={(newValue) =>
                handleChange(
                  f.name,
                  newValue ? newValue.format("YYYY-MM-DD") : "",
                )
              }
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  error: !!errors[f.name],
                  helperText: errors[f.name] || f.hint,
                },
              }}
            />
          ))}
        </LocalizationProvider>
      </Box>
      <Stack direction="row" spacing={1.5} justifyContent="flex-end" mt={3}>
        <Button
          onClick={onCancel}
          color="inherit"
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disableElevation
          onClick={handleSave}
          disabled={saving}
          startIcon={
            saving ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              <SaveIcon fontSize="small" />
            )
          }
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
            background: "linear-gradient(135deg, #FDE68A, #F59E0B)",
          }}
        >
          {saving ? "Saving" : "Save changes"}
        </Button>
      </Stack>
    </Box>
  );
}

// ””” Delete confirm dialog ””””””””””””””””””””””””””””””””””””””””””””””””””””

function DeleteDialog({ open, asset, token, activeOrg, onClose, onDeleted }) {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");
  const hasActiveBinding = Boolean(asset?.active_binding);
  const hasActiveLease = Boolean(
    (asset?.leases || []).some((lease) => lease?.lease_status === "ACTIVE"),
  );
  const hasOpenRma = Boolean(
    (asset?.rma_cases || []).some((rmaCase) =>
      ["OPEN", "IN_PROGRESS"].includes(rmaCase?.case_status),
    ),
  );

  const handleDelete = async () => {
    setDeleting(true);
    setError("");
    try {
      await axios.delete(`${API_BASE}/assets/${asset.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          ...(activeOrg ? { "X-Org-ID": activeOrg.id } : {}),
        },
      });
      onDeleted();
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Delete failed",
      );
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle fontWeight={700}>Delete asset?</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
            {error}
          </Alert>
        )}
        <DialogContentText>
          This will soft-delete <strong>{asset?.serial_number}</strong>. The
          record will be hidden from active inventory lists while preserving
          lifecycle history and audit data.
          {hasActiveBinding && (
            <Box
              component="span"
              sx={{
                display: "block",
                mt: 1.5,
                color: "error.main",
                fontWeight: 600,
              }}
            >
              Asset currently has an active device binding. Unbind it first.
            </Box>
          )}
          {hasActiveLease && (
            <Box
              component="span"
              sx={{
                display: "block",
                mt: 1.5,
                color: "error.main",
                fontWeight: 600,
              }}
            >
              Asset has an active lease. Close or terminate the lease first.
            </Box>
          )}
          {hasOpenRma && (
            <Box
              component="span"
              sx={{
                display: "block",
                mt: 1.5,
                color: "error.main",
                fontWeight: 600,
              }}
            >
              Asset has an open RMA case. Resolve the RMA workflow first.
            </Box>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          color="inherit"
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disableElevation
          disabled={deleting || hasActiveBinding || hasActiveLease || hasOpenRma}
          onClick={handleDelete}
          startIcon={
            deleting ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              <DeleteOutlineIcon />
            )
          }
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
        >
          {deleting ? "Deleting¦" : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// ””” Unbind confirm dialog ””””””””””””””””””””””””””””””””””””””””””””””””””””

function UnbindDialog({ open, binding, token, activeOrg, onClose, onUnbound }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleUnbind = async () => {
    setSubmitting(true);
    setError("");
    try {
      await axios.post(
        `${API_BASE}/bindings/${binding.id}/unbind`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            ...(activeOrg ? { "X-Org-ID": activeOrg.id } : {}),
          },
        },
      );
      onUnbound();
    } catch (err) {
      setError(err.response?.data?.error || "Unbind failed");
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle fontWeight={700}>Unbind device?</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
            {error}
          </Alert>
        )}
        <DialogContentText>
          This will remove the binding to device{" "}
          <strong>{binding?.device_id}</strong>. The asset status will return to{" "}
          <strong>IN_STOCK</strong>.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          color="inherit"
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="warning"
          disableElevation
          disabled={submitting}
          onClick={handleUnbind}
          startIcon={
            submitting ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              <LinkOffIcon />
            )
          }
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
        >
          {submitting ? "Unbinding¦" : "Unbind"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// ”””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””
// MAIN PAGE
// ”””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””””

export default function AssetDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { permissions, activeOrg } = useAuth();
  const { notification, showNotification, closeNotification } =
  useNotification();
  const token = localStorage.getItem("authToken");
  const isPlatformOwner =
    permissions?.has?.("*") || permissions?.has?.("system.manage");
  const orgType = (activeOrg?.type || "").toUpperCase();
  const isDistributor = orgType === "DISTRIBUTOR";
  const isReseller = orgType === "RESELLER";
  const isCustomer = orgType === "CUSTOMER";

  const [asset, setAsset] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editing, setEditing] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [unbindOpen, setUnbindOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [bindOpen, setBindOpen] = useState(false);
  const [movementOpen, setMovementOpen] = useState(false);
  const [movements, setMovements] = useState([]);
  const [leaseOpen, setLeaseOpen] = useState(false);
  const [leases, setLeases] = useState([]);
  const [rmaOpen, setRmaOpen] = useState(false);
  const [rmaCases, setRmaCases] = useState([]);
  //const [successMsg, setSuccessMsg] = useState("");

  const hasPermission = (p) => {
    if (!permissions || permissions.size === 0) return false;
    if (permissions.has("*")) return true;
    return permissions.has(p);
  };

  const authHeaders = {
    Authorization: `Bearer ${token}`,
    ...(activeOrg ? { "X-Org-ID": activeOrg.id } : {}),
  };

  // const showSuccess = (msg) => {
  //   setSuccessMsg(msg);
  //   setTimeout(() => setSuccessMsg(""), 5000);
  // };

  // ”” Fetch asset ””
  const fetchAsset = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/assets/${id}`, {
        headers: authHeaders,
      });
      setAsset(res.data?.data || res.data);
      setError(null);
    } catch (err) {
      if (err.response?.status === 404) setError("Asset not found.");
      else if (err.response?.status === 403)
        setError("You don't have permission to view this asset.");
      else setError("Failed to load asset details.");
    } finally {
      setLoading(false);
    }
  }, [id, token, activeOrg]);

  useEffect(() => {
    fetchAsset();
  }, [fetchAsset]);

  const fetchMovements = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE}/movements/${activeOrg.id}`, {
        headers: authHeaders,
        params: { asset_id: id, per_page: 10 },
      });
      setMovements(res.data.data || []);
    } catch {
      setMovements([]);
    }
  }, [id, token, activeOrg]);

  useEffect(() => {
    if (id) fetchMovements();
  }, [fetchMovements]);

  const fetchLeases = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE}/leases`, {
        headers: authHeaders,
        params: { asset_id: id, per_page: 5 },
      });
      setLeases(res.data.data || []);
    } catch {
      setLeases([]);
    }
  }, [id, token, activeOrg]);

  useEffect(() => {
    if (id) fetchLeases();
  }, [fetchLeases]);

  const fetchRmaCases = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE}/rma`, {
        headers: authHeaders,
        params: { asset_id: id, per_page: 5 },
      });
      setRmaCases(res.data.data || []);
    } catch {
      setRmaCases([]);
    }
  }, [id, token, activeOrg]);

  useEffect(() => {
    if (id) fetchRmaCases();
  }, [fetchRmaCases]);

  // Auto-open transfer modal if navigated with ?action=transfer
  useEffect(() => {
    if (searchParams.get("action") === "transfer" && asset) {
      setTransferOpen(true);
    }
  }, [searchParams, asset]);

  // ”” Handlers ””
  const handleSaved = (updatedAsset) => {
    setAsset(updatedAsset?.asset || updatedAsset?.data || updatedAsset);
    setEditing(false);
    showNotification("Asset updated successfully.", "success");
  };

  const handleTransferSuccess = (transfer, updatedAsset) => {
    setTransferOpen(false);
    fetchAsset();
    showNotification(`Ownership transferred successfully.`, "success");
  };

  const handleRmaSuccess = (rmaCase) => {
    setRmaOpen(false);
    fetchRmaCases();
    fetchAsset();
    showNotification("RMA case opened. The OEM team has been notified.", "success");
  };

  const handleLeaseSuccess = (lease) => {
    setLeaseOpen(false);
    fetchLeases();
    fetchAsset();
    showNotification("Lease created successfully.", "success");
  };

  const handleMovementSuccess = (movement) => {
    setMovementOpen(false);
    fetchMovements();
    showNotification("Movement logged successfully.", "success");
  };

  const handleBindSuccess = (binding, updatedAsset) => {
    setBindOpen(false);
    fetchAsset();
    showNotification(`Asset bound to device successfully. Status is now DEPLOYED.`, "success");
  };

  const handleDeleted = () => {
    navigate("/inventory/assets", { replace: true });
  };

  const handleUnbound = () => {
    setUnbindOpen(false);
    fetchAsset();
    showNotification("Asset unbound from device. Status is now IN_STOCK.", "success");
  };

  // ”” Loading skeleton ””
  if (loading)
    return (
      <Box sx={{ maxWidth: 1100, margin: "0 auto", p: { xs: 2, md: 3 } }}>
        <Skeleton variant="text" width={200} height={32} sx={{ mb: 3 }} />
        <Skeleton
          variant="rounded"
          height={200}
          sx={{ mb: 3, borderRadius: 3 }}
        />
        <Skeleton
          variant="rounded"
          height={180}
          sx={{ mb: 3, borderRadius: 3 }}
        />
        <Skeleton variant="rounded" height={180} sx={{ borderRadius: 3 }} />
      </Box>
    );

  if (error)
    return (
      <Box sx={{ maxWidth: 1100, margin: "0 auto", p: { xs: 2, md: 3 } }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ textTransform: "none", mb: 2 }}
        >
          Back
        </Button>
        <Alert severity="error" sx={{ borderRadius: 2 }}>
          {error}
        </Alert>
      </Box>
    );

  const activeBinding = asset.active_binding;
  const transfers = asset.ownership_transfers || [];
  const assetWithLifecycle = {
    ...asset,
    leases,
    rma_cases: rmaCases,
  };
  const ownerOrgLabel = formatOrgLabel(
    asset.owner_org,
    asset.owner_org_id,
    asset.owner_type,
  );
  const assignedOrgLabel = formatOrgLabel(
    asset.assigned_org,
    asset.organization_id,
  );
  const custodyLabel =
    asset.assigned_org?.name || asset.organization_id
      ? assignedOrgLabel
      : ownerOrgLabel;
  const canProvisionFromAsset =
    asset.status === "IN_STOCK" &&
    !activeBinding &&
    hasPermission("device.create");
  const assetTypeDefinition = asset.asset_type_definition || null;
  const typedMetadataEntries = (assetTypeDefinition?.fields || [])
    .map((field) => ({
      key: field.field_key,
      label: field.label,
      value: asset.custom_attributes?.[field.field_key],
      required: field.required,
    }))
    .filter(
      (entry) =>
        entry.required ||
        (entry.value !== null &&
          entry.value !== undefined &&
          entry.value !== "" &&
          (!Array.isArray(entry.value) || entry.value.length > 0)),
    );
  const transferLabel = isPlatformOwner
    ? "Transfer"
    : isDistributor || isReseller
      ? "Sell / transfer onward"
      : "Transfer asset";
  const readinessSummary = canProvisionFromAsset
    ? "This asset is in stock and unbound. It is ready for downstream provisioning once the matching device family is selected."
    : asset.status !== "IN_STOCK"
      ? "This asset is not currently provisionable because it is not in stock."
      : activeBinding
        ? "This asset is already tied to a logical device. Unbind it before provisioning again."
        : "This asset stays visible in inventory, but provisioning depends on your device creation permission and device-family compatibility.";

  return (
    <Box
      sx={{
        margin: "0 auto",
        p: { xs: 2, md: 3 },
        background:
          "radial-gradient(circle at top left, rgba(14, 165, 233, 0.14), transparent 30%), radial-gradient(circle at top right, rgba(16, 185, 129, 0.12), transparent 28%), linear-gradient(180deg, #F8FBFF 0%, #EEF4F8 100%)",
      }}
    >
      {/* ”” Header ”” */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={3}
        flexWrap="wrap"
        gap={2}
        sx={{
          border: "1px solid rgba(148, 163, 184, 0.18)",
          background:
            "linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",
          borderRadius: "14px",
          padding: "20px 24px",
        }}
      >
        <Box>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/inventory/assets")}
            sx={{
              textTransform: "none",
              mb: 0.5,
              pl: 0,
              color: "rgba(203, 213, 225, 0.80)",
              "&:hover": { color: "#94d8d0", background: "transparent" },
            }}
          >
            Hardware Inventory
          </Button>
          <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{
                fontFamily: "monospace",
                color: "#e2f8f5",
                letterSpacing: "0.04em",
              }}
            >
              {asset.serial_number}
            </Typography>
            <StatusChip status={asset.status} />
            <OwnershipChip state={asset.ownership_state} />
          </Box>
          <Typography
            variant="body2"
            mt={0.5}
            sx={{ color: "rgba(203, 213, 225, 0.90)" }}
          >
            {asset.asset_type} · {asset.model}
            {asset.manufacturer ? ` · ${asset.manufacturer}` : ""}
          </Typography>
        </Box>

        {/* Action buttons */}
        <Stack direction="row" spacing={1} flexWrap="wrap">
          {!isPlatformOwner && canProvisionFromAsset && (
            <Button
              startIcon={<DevicesIcon />}
              variant="contained"
              size="small"
              onClick={() =>
                navigate(`/device_onboarding?inventory_asset_id=${asset.id}`)
              }
              sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
            >
              Provision device
            </Button>
          )}
          {isPlatformOwner &&
            hasPermission("inventory.asset.update") &&
            !editing && (
              <Button
                startIcon={<EditIcon />}
                variant="outlined"
                size="small"
                onClick={() => setEditing(true)}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                  color: "#cbd5e1",
                  borderColor: "rgba(148, 163, 184, 0.3)",
                  background: "rgba(255,255,255,0.06)",
                  "&:hover": {
                    borderColor: "rgba(148, 163, 184, 0.5)",
                    background: "rgba(255,255,255,0.10)",
                    color: "#e2e8f0",
                  },
                }}
              >
                Edit
              </Button>
            )}
          {hasPermission("inventory.transfer.create") && (
            <Button
              startIcon={<SwapHorizIcon />}
              variant="outlined"
              size="small"
              onClick={() => setTransferOpen(true)}
              disabled={asset.status === "DEPLOYED" || !!asset.active_binding}
              sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
            >
              {transferLabel}
            </Button>
          )}
          {isPlatformOwner && hasPermission("inventory.asset.delete") && (
            <Button
              startIcon={<DeleteOutlineIcon />}
              variant="outlined"
              size="small"
              onClick={() => setDeleteOpen(true)}
              disabled={
                !!asset.active_binding ||
                leases.some((lease) => lease?.lease_status === "ACTIVE") ||
                rmaCases.some((rmaCase) =>
                  ["OPEN", "IN_PROGRESS"].includes(rmaCase?.case_status),
                )
              }
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 2,
                color: "#fca5a5",
                borderColor: "rgba(239, 68, 68, 0.28)",
                background: "rgba(239, 68, 68, 0.10)",
                "&:hover": {
                  borderColor: "rgba(239, 68, 68, 0.45)",
                  background: "rgba(239, 68, 68, 0.18)",
                },
                "&.Mui-disabled": {
                  color: "rgba(203, 213, 225, 0.30)",
                  borderColor: "rgba(148, 163, 184, 0.15)",
                },
              }}
            >
              Delete
            </Button>
          )}
        </Stack>
      </Stack>

      {/* Alerts */}
      <Collapse in={notification.open}>
  <Alert
    severity={notification.severity}
    sx={{ mb: 3, borderRadius: 2 }}
    onClose={closeNotification}
  >
    {notification.message}
  </Alert>
</Collapse>

      {!isPlatformOwner && (
        <Alert
          severity={canProvisionFromAsset ? "success" : "info"}
          sx={{ mb: 3, borderRadius: 2 }}
        >
          <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5 }}>
            Current custody: {custodyLabel}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {readinessSummary}
          </Typography>
        </Alert>
      )}

      {/* ”” Edit mode ”” */}
      {editing ? (
        <Card
          elevation={0}
          sx={{
            border: "1px solid rgba(148, 163, 184, 0.18)",
            borderRadius: "16px",
            mb: 3,
            overflow: "hidden",

            // subtle overall bg (not white)
            background: "#F8FAFC",

            boxShadow: "0 10px 40px rgba(2, 6, 23, 0.08)",
          }}
        >
          {/* HEADER */}
          <CardHeader
            title={
              <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{ color: "#F1F5F9" }}
              >
                Edit asset
              </Typography>
            }
            subheader={
              <Typography
                variant="caption"
                sx={{ color: "rgba(203, 213, 225, 0.75)" }}
              >
                serial_number and status cannot be changed here
              </Typography>
            }
            action={
              <IconButton
                onClick={() => setEditing(false)}
                sx={{
                  color: "rgba(203, 213, 225, 0.75)",
                  "&:hover": {
                    color: "#fff",
                    background: "rgba(255,255,255,0.08)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            }
            sx={{
              px: 3,
              py: 2,
              borderBottom: "1px solid rgba(255,255,255,0.06)",

              background:
                "linear-gradient(135deg, #0f172a 0%, #0f766e 55%, #083344 100%)",

              boxShadow: "inset 0 -1px 0 rgba(255,255,255,0.05)",
            }}
          />

          {/* CONTENT */}
          <CardContent
            sx={{
              px: { xs: 2, sm: 3 },
              py: 3,

              // soft gradient instead of plain white
              background:
                "linear-gradient(180deg, rgba(248,250,252,0.9), rgba(241,245,249,0.9))",

              // spacing
              "& .MuiTextField-root": {
                mb: 2,
              },

              // INPUT STYLE (clean + soft)
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                background: "#ffffff",

                transition: "all 0.2s ease",

                "& fieldset": {
                  borderColor: "#E2E8F0",
                },

                "&:hover fieldset": {
                  borderColor: "#6366F1",
                },

                "&.Mui-focused": {
                  background: "#fff",
                },

                "&.Mui-focused fieldset": {
                  borderColor: "#6366F1",
                  boxShadow: "0 0 0 3px rgba(99,102,241,0.12)",
                },
              },

              // LABEL
              "& .MuiInputLabel-root": {
                fontSize: 12,
                fontWeight: 500,
                color: "#64748B",
              },
            }}
          >
            <EditForm
              asset={asset}
              token={token}
              activeOrg={activeOrg}
              onSave={handleSaved}
              onCancel={() => setEditing(false)}
            />
          </CardContent>
        </Card>
      ) : (
        <>
          {/* ”” Section 1: Identity ”” */}
          <SectionCard
            title="Identity & hardware"
            icon={<DevicesIcon color="primary" />}
            action={
              isPlatformOwner &&
              hasPermission("inventory.asset.update") && (
                <Tooltip title="Edit">
                  <IconButton size="small" onClick={() => setEditing(true)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )
            }
          >
            <Box
              display="grid"
              gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
              gap={3}
            >
              <Box>
                <Typography
                  variant="overline"
                  color="text.secondary"
                  fontWeight={700}
                  display="block"
                  mb={1}
                >
                  Identity
                </Typography>
                <InfoRow
                  label="Serial number"
                  value={asset.serial_number}
                  mono
                />
                <InfoRow label="Asset type" value={asset.asset_type} />
                <InfoRow label="Model" value={asset.model} />
                <InfoRow label="Manufacturer" value={asset.manufacturer} />
                <InfoRow
                  label="Batch number"
                  value={asset.manufacturing_batch}
                />
              </Box>
              <Box>
                <Typography
                  variant="overline"
                  color="text.secondary"
                  fontWeight={700}
                  display="block"
                  mb={1}
                >
                  Hardware IDs
                </Typography>
                <InfoRow label="IMEI" value={asset.imei} mono />
                <InfoRow label="MAC address" value={asset.mac_address} mono />
                <InfoRow label="QR code" value={asset.qr_code} mono />
                <InfoRow label="Purchase order" value={asset.purchase_order} />
                <InfoRow label="Invoice number" value={asset.invoice_number} />
              </Box>
            </Box>
          </SectionCard>

          {/* ”” Section 2: Ownership ”” */}
          {assetTypeDefinition ? (
            <SectionCard
              title="Asset type definition"
              icon={<CategoryIcon color="action" />}
            >
              <Box
                display="grid"
                gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
                gap={3}
              >
                <Box>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    fontWeight={700}
                    display="block"
                    mb={1}
                  >
                    Type profile
                  </Typography>
                  <InfoRow label="Name" value={assetTypeDefinition.name} />
                  <InfoRow label="Code" value={assetTypeDefinition.code} mono />
                  <InfoRow
                    label="Category"
                    value={assetTypeDefinition.category}
                  />
                  <InfoRow
                    label="Description"
                    value={assetTypeDefinition.description}
                  />
                </Box>
                <Box>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    fontWeight={700}
                    display="block"
                    mb={1}
                  >
                    Type-specific metadata
                  </Typography>
                  {typedMetadataEntries.length ? (
                    typedMetadataEntries.map((entry) => (
                      <InfoRow
                        key={entry.key}
                        label={entry.label}
                        value={formatTypedValue(entry.value)}
                      />
                    ))
                  ) : (
                    <Box textAlign="center" py={2}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontWeight={600}
                      >
                        No typed metadata captured
                      </Typography>
                      <Typography variant="caption" color="text.disabled">
                        This asset type has a standard definition, but no custom
                        field values were saved for this asset yet.
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </SectionCard>
          ) : null}

          <SectionCard
            title="Ownership"
            icon={<SwapHorizIcon color="secondary" />}
            action={
              hasPermission("inventory.transfer.create") && (
                <Button
                  size="small"
                  startIcon={<SwapHorizIcon />}
                  onClick={() => setTransferOpen(true)}
                  disabled={
                    asset.status === "DEPLOYED" || !!asset.active_binding
                  }
                  sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}
                >
                  Transfer
                </Button>
              )
            }
          >
            <Box
              display="grid"
              gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
              gap={3}
              mb={3}
            >
              <Box>
                <Typography
                  variant="overline"
                  color="text.secondary"
                  fontWeight={700}
                  display="block"
                  mb={1}
                >
                  Current owner
                </Typography>
                <InfoRow label="Owner type" value={asset.owner_type} />
                <InfoRow label="Owner org" value={ownerOrgLabel} />
                <InfoRow
                  label="Ownership state"
                  value={asset.ownership_state?.replace(/_/g, " ")}
                />
                <InfoRow
                  label={isPlatformOwner ? "Assigned org" : "Current custody"}
                  value={assignedOrgLabel}
                />
              </Box>
              <Box>
                <Typography
                  variant="overline"
                  color="text.secondary"
                  fontWeight={700}
                  display="block"
                  mb={1}
                >
                  Procurement
                </Typography>
                <InfoRow label="Source" value={asset.procurement_source} />
                <InfoRow label="Purchase order" value={asset.purchase_order} />
                <InfoRow label="Invoice" value={asset.invoice_number} />
              </Box>
            </Box>

            {/* Transfer timeline */}
            {transfers.length > 0 && (
              <>
                <Divider sx={{ mb: 2 }} />
                <Typography
                  variant="overline"
                  color="text.secondary"
                  fontWeight={700}
                  display="block"
                  mb={1.5}
                >
                  Ownership history ({transfers.length})
                </Typography>
                <Paper
                  variant="outlined"
                  sx={{ borderRadius: 2, overflow: "hidden" }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow
                        sx={{
                          "& th": {
                            bgcolor: "background.default",
                            fontWeight: 700,
                            fontSize: 11,
                            color: "text.secondary",
                          },
                        }}
                      >
                        <TableCell>Type</TableCell>
                        <TableCell>From</TableCell>
                        <TableCell>To</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Date</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {transfers.map((t) => (
                        <TableRow key={t.id} hover>
                          <TableCell sx={{ fontSize: 12 }}>
                            <Chip
                              label={t.transfer_type?.replace(/_/g, " ")}
                              size="small"
                              variant="outlined"
                              sx={{ fontSize: 10, height: 20 }}
                            />
                          </TableCell>
                          <TableCell sx={{ fontSize: 12 }}>
                            {t.from_owner_type}
                            {` · ${formatOrgLabel(
                              t.from_owner_org,
                              t.from_owner_org_id,
                              t.from_owner_type,
                            )}`}
                          </TableCell>
                          <TableCell sx={{ fontSize: 12 }}>
                            {t.to_owner_type}
                            {` · ${formatOrgLabel(
                              t.to_owner_org,
                              t.to_owner_org_id,
                              t.to_owner_type,
                            )}`}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={t.transfer_status}
                              size="small"
                              color="success"
                              variant="outlined"
                              sx={{ fontSize: 10, height: 20 }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: 11,
                              color: "text.secondary",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t.transferred_at
                              ? new Date(t.transferred_at).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "numeric",
                                    month: "short",
                                    year: "numeric",
                                  },
                                )
                              : ""}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </>
            )}
          </SectionCard>

          {/* ”” Section 3: Device binding ”” */}
          <SectionCard
            title="Device binding"
            icon={<LinkIcon color="action" />}
            action={
              activeBinding &&
              hasPermission("inventory.binding.remove") && (
                <Button
                  size="small"
                  color="warning"
                  startIcon={<LinkOffIcon />}
                  onClick={() => setUnbindOpen(true)}
                  sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}
                >
                  Unbind
                </Button>
              )
            }
          >
            {activeBinding ? (
              <Box>
                <Alert
                  severity="success"
                  icon={<LinkIcon />}
                  sx={{ mb: 2, borderRadius: 2 }}
                >
                  Currently bound to device
                </Alert>
                <InfoRow
                  label="Device ID"
                  value={activeBinding.device_id}
                  mono
                />
                <InfoRow
                  label="Bound at"
                  value={
                    activeBinding.bound_at
                      ? new Date(activeBinding.bound_at).toLocaleString("en-IN")
                      : ""
                  }
                />
                <InfoRow label="Bound by" value={activeBinding.bound_by} mono />
              </Box>
            ) : (
              <Box textAlign="center" py={2}>
                <LinkOffIcon
                  sx={{ fontSize: 36, color: "text.disabled", mb: 1 }}
                />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight={600}
                >
                  Not bound to any device
                </Typography>
                <Typography variant="caption" color="text.disabled">
                  {canProvisionFromAsset
                    ? "This asset is ready for provisioning or a direct bind flow."
                    : asset.ownership_state === "OWNED_BY_CUSTOMER"
                      ? "This asset is customer-ready, but provisioning depends on workspace permissions and family compatibility."
                      : "Transfer or receive the asset into the correct downstream custody state before binding."}
                </Typography>
                {asset.ownership_state === "OWNED_BY_CUSTOMER" &&
                  hasPermission("inventory.binding.create") && (
                    <Box mt={2}>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1}
                        justifyContent="center"
                      >
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<LinkIcon />}
                          onClick={() => setBindOpen(true)}
                          sx={{ textTransform: "none", fontWeight: 600 }}
                        >
                          Bind to device
                        </Button>
                        {canProvisionFromAsset && (
                          <Button
                            size="small"
                            variant="contained"
                            startIcon={<DevicesIcon />}
                            onClick={() =>
                              navigate(
                                `/device_onboarding?inventory_asset_id=${asset.id}`,
                              )
                            }
                            sx={{ textTransform: "none", fontWeight: 600 }}
                          >
                            Provision device
                          </Button>
                        )}
                      </Stack>
                    </Box>
                  )}
              </Box>
            )}
          </SectionCard>

          {/* ”” Section 4: Movements ”” */}
          <SectionCard
            title="Movement history"
            icon={<LocalShippingIcon color="action" />}
            action={
              hasPermission("inventory.movement.create") && (
                <Button
                  size="small"
                  startIcon={<LocalShippingIcon />}
                  onClick={() => setMovementOpen(true)}
                  sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}
                >
                  Log movement
                </Button>
              )
            }
          >
            {movements.length === 0 ? (
              <Box textAlign="center" py={2}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight={600}
                >
                  No movements recorded
                </Typography>
                <Typography variant="caption" color="text.disabled">
                  Physical shipments and transfers will appear here
                </Typography>
              </Box>
            ) : (
              <Paper
                variant="outlined"
                sx={{ borderRadius: 2, overflow: "hidden" }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          bgcolor: "background.default",
                          fontWeight: 700,
                          fontSize: 11,
                          color: "text.secondary",
                        },
                      }}
                    >
                      <TableCell>Type</TableCell>
                      <TableCell>From</TableCell>
                      <TableCell>To</TableCell>
                      <TableCell>Courier</TableCell>
                      <TableCell>Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {movements.map((m) => (
                      <TableRow key={m.id} hover>
                        <TableCell>
                          <Chip
                            label={m.movement_type}
                            size="small"
                            variant="outlined"
                            sx={{ fontSize: 10, height: 20 }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: 12, color: "text.secondary" }}
                        >
                          {m.from_location_name || ""}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: 12, color: "text.secondary" }}
                        >
                          {m.to_location_name || ""}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: 12, color: "text.secondary" }}
                        >
                          {m.courier_name || ""}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: 11,
                            color: "text.secondary",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {m.moved_at
                            ? new Date(m.moved_at).toLocaleDateString("en-IN", {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                              })
                            : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            )}
          </SectionCard>

          {/* ”” Section 5: Leases ”” */}
          <SectionCard
            title="Leases"
            icon={<HandshakeIcon color="action" />}
            action={
              hasPermission("inventory.lease.create") &&
              asset.ownership_state === "OWNED_BY_CUSTOMER" && (
                <Button
                  size="small"
                  startIcon={<HandshakeIcon />}
                  onClick={() => setLeaseOpen(true)}
                  sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}
                >
                  Create lease
                </Button>
              )
            }
          >
            {leases.length === 0 ? (
              <Box textAlign="center" py={2}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight={600}
                >
                  No leases recorded
                </Typography>
                <Typography variant="caption" color="text.disabled">
                  {asset.ownership_state === "OWNED_BY_CUSTOMER"
                    ? "Create a lease agreement for this asset"
                    : "Asset must be OWNED_BY_CUSTOMER before leasing"}
                </Typography>
              </Box>
            ) : (
              <Paper
                variant="outlined"
                sx={{ borderRadius: 2, overflow: "hidden" }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          bgcolor: "background.default",
                          fontWeight: 700,
                          fontSize: 11,
                          color: "text.secondary",
                        },
                      }}
                    >
                      <TableCell>Status</TableCell>
                      <TableCell>Period</TableCell>
                      <TableCell>Rate</TableCell>
                      <TableCell>Contract ref</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {leases.map((l) => (
                      <TableRow key={l.id} hover>
                        <TableCell>
                          <Chip
                            label={l.lease_status}
                            size="small"
                            variant="outlined"
                            color={
                              l.lease_status === "ACTIVE"
                                ? "success"
                                : "default"
                            }
                            sx={{ fontSize: 10, height: 20 }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: 12, color: "text.secondary" }}
                        >
                          {l.start_date} †’ {l.end_date}
                        </TableCell>
                        <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>
                          {l.currency}{" "}
                          {parseFloat(l.rate).toLocaleString("en-IN")}
                          <Typography
                            component="span"
                            variant="caption"
                            color="text.secondary"
                            sx={{ ml: 0.5 }}
                          >
                            /{l.billing_cycle?.toLowerCase()}
                          </Typography>
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: 12, color: "text.secondary" }}
                        >
                          {l.contract_reference || ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            )}
          </SectionCard>

          {/* ”” Section 6: RMA Cases ”” */}
          <SectionCard
            title="RMA cases"
            icon={<ReportProblemIcon color="action" />}
            action={
              hasPermission("inventory.rma.create") && (
                <Button
                  size="small"
                  color="warning"
                  startIcon={<ReportProblemIcon />}
                  onClick={() => setRmaOpen(true)}
                  sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}
                >
                  Open RMA case
                </Button>
              )
            }
          >
            {rmaCases.length === 0 ? (
              <Box textAlign="center" py={2}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight={600}
                >
                  No RMA cases
                </Typography>
                <Typography variant="caption" color="text.disabled">
                  Open a case if this device is faulty or needs to be returned
                </Typography>
              </Box>
            ) : (
              <Paper
                variant="outlined"
                sx={{ borderRadius: 2, overflow: "hidden" }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          bgcolor: "background.default",
                          fontWeight: 700,
                          fontSize: 11,
                          color: "text.secondary",
                        },
                      }}
                    >
                      <TableCell>Status</TableCell>
                      <TableCell>Fault type</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Resolution</TableCell>
                      <TableCell>Opened</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rmaCases.map((c) => (
                      <TableRow key={c.id} hover>
                        <TableCell>
                          <Chip
                            label={c.case_status?.replace(/_/g, " ")}
                            size="small"
                            variant="outlined"
                            color={
                              c.case_status === "OPEN"
                                ? "warning"
                                : c.case_status === "IN_PROGRESS"
                                  ? "info"
                                  : c.case_status === "RESOLVED" ||
                                      c.case_status === "CLOSED"
                                    ? "success"
                                    : "default"
                            }
                            sx={{ fontSize: 10, height: 20 }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: 12, color: "text.secondary" }}
                        >
                          {c.fault_type?.replace(/_/g, " ")}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: 12,
                            color: "text.secondary",
                            maxWidth: 200,
                          }}
                        >
                          <Typography
                            variant="body2"
                            noWrap
                            sx={{ fontSize: 12 }}
                            title={c.fault_description}
                          >
                            {c.fault_description}
                          </Typography>
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: 12, color: "text.secondary" }}
                        >
                          {c.resolution_type?.replace(/_/g, " ") || ""}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: 11,
                            color: "text.secondary",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {c.opened_at
                            ? new Date(c.opened_at).toLocaleDateString(
                                "en-IN",
                                {
                                  day: "numeric",
                                  month: "short",
                                  year: "numeric",
                                },
                              )
                            : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            )}
          </SectionCard>

          {/* ”” Section 7: Warranty & audit ”” */}
          <Card
            elevation={0}
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 3,
              mb: 3,
            }}
          >
            <CardContent>
              <Box
                display="grid"
                gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
                gap={3}
              >
                <Box>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    fontWeight={700}
                    display="block"
                    mb={1}
                  >
                    Warranty
                  </Typography>
                  <InfoRow label="Start date" value={asset.warranty_start} />
                  <InfoRow label="End date" value={asset.warranty_end} />
                  <Box mt={1.5}>
                    <WarrantyStatus
                      warrantyStart={asset.warranty_start}
                      warrantyEnd={asset.warranty_end}
                    />
                  </Box>
                </Box>
                <Box>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    fontWeight={700}
                    display="block"
                    mb={1}
                  >
                    Audit
                  </Typography>
                  <InfoRow
                    label="Registered"
                    value={
                      asset.created_at
                        ? new Date(asset.created_at).toLocaleString("en-IN")
                        : ""
                    }
                  />
                  <InfoRow
                    label="Last updated"
                    value={
                      asset.updated_at
                        ? new Date(asset.updated_at).toLocaleString("en-IN")
                        : ""
                    }
                  />
                  <InfoRow label="Asset ID" value={asset.id} mono />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </>
      )}

      {/* ”” Dialogs ”” */}
      <DeleteDialog
        open={deleteOpen}
        asset={assetWithLifecycle}
        token={token}
        activeOrg={activeOrg}
        onClose={() => setDeleteOpen(false)}
        onDeleted={handleDeleted}
      />

      <UnbindDialog
        open={unbindOpen}
        binding={activeBinding}
        token={token}
        activeOrg={activeOrg}
        onClose={() => setUnbindOpen(false)}
        onUnbound={handleUnbound}
      />

      <TransferModal
        open={transferOpen}
        asset={asset}
        token={token}
        activeOrg={activeOrg}
        onClose={() => setTransferOpen(false)}
        onSuccess={handleTransferSuccess}
      />

      <DevicePickerModal
        open={bindOpen}
        asset={asset}
        token={token}
        activeOrg={activeOrg}
        onClose={() => setBindOpen(false)}
        onSuccess={handleBindSuccess}
      />

      <LogMovementModal
        open={movementOpen}
        asset={asset}
        token={token}
        activeOrg={activeOrg}
        onClose={() => setMovementOpen(false)}
        onSuccess={handleMovementSuccess}
      />

      <CreateLeaseModal
        open={leaseOpen}
        asset={asset}
        token={token}
        activeOrg={activeOrg}
        onClose={() => setLeaseOpen(false)}
        onSuccess={handleLeaseSuccess}
      />

      <OpenRMAModal
        open={rmaOpen}
        asset={asset}
        token={token}
        activeOrg={activeOrg}
        onClose={() => setRmaOpen(false)}
        onSuccess={handleRmaSuccess}
      />
    </Box>
  );
}

